module.exports = __webpack_public_path__ + "img/logo_dailysocial.a76fc0e2.png";